
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pass/point",
      function () {
        return require("private-next-pages/pass/point/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pass/point"])
      });
    }
  